import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import Images3DVisualisationArchitecturale from "@/pages/Images3DVisualisationArchitecturale";

export const Route = createFileRoute("/images-3d-visualisation-architecturale")({
  head: () =>
    routeHead({
      path: '/images-3d-visualisation-architecturale',
      title: 'Images 3D & visualisation architecturale Lyon | JIIA Studio',
      description: 'Rendus 3D photoréalistes pour vos projets à Lyon : perspectives intérieures, extérieures et vues aériennes réalisées par JIIA Studio.',
    }),
  component: Images3DVisualisationArchitecturale,
});
